import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import '../show-list/geozone-list.sass';
import { Alert, AlertTitle, Box, Button, DialogContentText, Hidden } from '@mui/material';
import { GeozoneList } from './list';
import { SearchField } from 'shared/components/fields/search';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { findGeozoneFromId } from '../../utils/utils';
import { deleteGeozoneFromList, geozones_attachment_set_message_action, upload_geozones_from_file_action, } from '../../model/actions';
import { zoomOnGeozone } from 'shared/map/model/actions';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { LoadingButton } from '@mui/lab';
import { Download, Publish } from '@mui/icons-material';
import { FileType } from 'console/utils/download-files/download_file';
import { useDropzone } from 'react-dropzone';
import { useAPI } from 'console/shared/api/api-context';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
function findItem(geozones, search) {
    const search_trim = search.trim();
    if (!search_trim)
        return geozones;
    const search_lower = search_trim.toLowerCase();
    return geozones.filter((gz) => gz.geojson.properties?.name.toLowerCase().indexOf(search_lower) !== -1);
}
export function GeozoneListDialogImpl(props) {
    const { open, geozones, onCloseDialog, openGeozoneProperties, deleteGeozone, onZoomOnGeozone, } = props;
    const api = useAPI();
    const upload_files = useAction(upload_geozones_from_file_action);
    const set_error = useAction(geozones_attachment_set_message_action);
    const { error, is_loading } = useAppSelector((state) => state.geozones_uploading_info);
    let filter_geozones = geozones;
    const geozones_count = geozones.length;
    const [search, setSearch] = useState('');
    useEffect(() => {
        set_error(null);
    }, [open, geozones]);
    const onChangeSearch = useCallback((value) => {
        setSearch(value);
    }, [setSearch]);
    const onClearSearch = useCallback(() => {
        setSearch('');
    }, [setSearch]);
    filter_geozones = useMemo(() => findItem(filter_geozones, search), [filter_geozones, search, geozones]);
    const onGeozoneSelect = useCallback((select_id) => {
        onZoomOnGeozone(select_id);
        onCloseDialog();
    }, [onCloseDialog, onZoomOnGeozone]);
    const onOpenGeozoneProperties = useCallback((geozone_id) => {
        openGeozoneProperties(geozone_id);
    }, [openGeozoneProperties]);
    const onDeleteGeozone = useCallback((geozone_id) => {
        const geozone = findGeozoneFromId(geozones, geozone_id);
        if (geozone != null) {
            deleteGeozone(geozone);
        }
    }, [deleteGeozone, geozones]);
    const downloadGeozoneKML = (method) => {
        return (window.location.href = api.get_url(method, {
            filename: 'geozones.kml',
        }, true));
    };
    const downloadGeozones = useCallback(() => {
        downloadGeozoneKML('download_kml_geozones');
    }, [geozones]);
    const onDrop = useCallback((accepted_files) => {
        if (accepted_files == null) {
            return;
        }
        upload_files(accepted_files.map((a_file) => a_file));
    }, [upload_files]);
    const input_ref = useRef(null);
    const onUploadGeozone = useCallback(() => {
        if (input_ref.current != null) {
            input_ref.current.click();
        }
    }, [geozones]);
    const { getRootProps, getInputProps } = useDropzone({ onDrop });
    const { ref, ...rootProps } = getRootProps();
    return (_jsxs(MessageBox, { open: open, onClose: onCloseDialog, title: `Список геозон: ${' ' + geozones_count}`, maxWidth: "md", withoutHorizontalPadding: true, footer: _jsxs(_Fragment, { children: [_jsx(Box, { m: 1, children: _jsx(Button, { onClick: downloadGeozones, variant: "contained", color: "success", startIcon: _jsx(Download, {}), children: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0433\u0435\u043E\u0437\u043E\u043D\u044B" }) }), _jsx(Box, { m: 1, children: _jsxs(Hidden, { mdDown: true, ...rootProps, children: [_jsx(LoadingButton, { variant: "contained", startIcon: _jsx(Publish, {}), onClick: onUploadGeozone, loading: is_loading, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0433\u0435\u043E\u0437\u043E\u043D\u044B" }), _jsx("input", { ...getInputProps(), type: 'file', ref: input_ref, accept: `${FileType.kml}`, multiple: false })] }) })] }), children: [_jsx(Box, { mx: 1, mb: 2, children: _jsx(SearchField, { value: search, onChange: onChangeSearch, onClear: onClearSearch }) }), error != null && (_jsx(Box, { mx: 1, children: _jsxs(Alert, { severity: "error", children: [_jsx(AlertTitle, { children: error.title }), error.message] }) })), geozones_count > 0 ? (_jsx(Box, { mx: 1, children: _jsx(GeozoneList, { geozones: filter_geozones, onGeozoneSelect: onGeozoneSelect, onOpenGeozoneProperties: onOpenGeozoneProperties, onDeleteGeozone: onDeleteGeozone }) })) : (_jsx(Box, { ml: 1, children: _jsx(DialogContentText, { children: "\u041D\u0435\u0442 \u043D\u0438 \u043E\u0434\u043D\u043E\u0439 \u0433\u0435\u043E\u0437\u043E\u043D\u044B" }) }))] }));
}
export const GeozoneListDialog = connect(createStructuredSelector({
    geozones: (state) => state.geozones ?? [],
}), {
    deleteGeozone: deleteGeozoneFromList,
    onZoomOnGeozone: zoomOnGeozone,
})(GeozoneListDialogImpl);
